module.exports = __webpack_public_path__ + "img/sample_map2.8e2d64fb.png";